import React from 'react';
import { Box, Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = {
    container: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f6f5f6'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '310px',
        maxWidth: '95%',
        alignItems: 'center'
    },
    logoIcon: {
        width: '125%',
        alignSelf: 'center',
        marginBottom: '16px'
    },
    clinicShortname: {
        fontFamily: 'monospace',
        backgroundColor: '#dbd9db',
        padding: '1px 4px',
        borderRadius: '4px',
        display: 'inline-block',
        lineHeight: 1.5
    },
    notFoundText: {
        lineHeight: 2,
        textAlign: 'center'
    }
};

const NotFoundView = ({ classes }) => {
    return (
        <Box className={classes.container}>
            <Box className={classes.content}>
                <img className={classes.logoIcon} src={'/images/collums_logo.png'} alt="collums-logo" />
                <Typography variant="h4" className={classes.notFoundText}>
                    The URL in your browser address bar is not valid.
                    <br />
                    Please check the URL is correct and try again.
                </Typography>
            </Box>
        </Box>
    );
};

NotFoundView.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NotFoundView);
